import { Analytics, AnalyticsBrowser } from '@segment/analytics-next';

export const createAnalytics = async (): Promise<Analytics> => {
  const [analytics] = await AnalyticsBrowser.load({
    writeKey: process.env.VUE_APP_SEGMENT_WRITE_KEY || '',
  });

  return analytics;
};
